import React from "react"
import { MediaContent, Button } from "@capioweb/ui-components"
import {
	StringProperty,
	LinkProperty,
	BooleanProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { QBankImage, XhtmlString } from "../../@types/CapioWeb/core"
import { BlockCommonLayout } from "../../utils/layout"
import { urlIsInternal, imageBlockDataToImageProps } from "../../utils"
import { sendCtaClickLayerPush } from "../../utils/piwikPro"

interface CapioNexusEnlistBlockProps {
	heading: StringProperty
	imageBlock: QBankImage
	linkItem: LinkProperty
	preamble: XhtmlString
	rightSideImage: BooleanProperty
	anchorId?: StringProperty
}

const CapioNexusEnlistBlock: React.FC<CapioNexusEnlistBlockProps> = ({
	imageBlock,
	linkItem,
	preamble,
	rightSideImage,
	anchorId,
	...rest
}) => {
	const srcSetSizes = [{ width: 800, breakpoint: 2560 }]
	return (
		<BlockCommonLayout id={anchorId?.value || null} {...rest}>
			<MediaContent
				mirror={rightSideImage?.value}
				media={
					<img
						{...imageBlockDataToImageProps(imageBlock, true, true, srcSetSizes)}
					/>
				}
				cta={
					linkItem && linkItem?.href ? (
						!urlIsInternal(linkItem.href) ? (
							<Button.Anchor
								display={{ _: "block", l: "inline-flex" }}
								href={linkItem?.href}
								target={linkItem?.target}
								onClick={() => sendCtaClickLayerPush(linkItem?.text)}
							>
								{linkItem?.text}
							</Button.Anchor>
						) : (
							<Button.Link
								display={{ _: "block", l: "inline-flex" }}
								to={linkItem?.href ?? "#"}
								target={linkItem?.target}
								onClick={() => sendCtaClickLayerPush(linkItem?.text)}
							>
								{linkItem?.text}
							</Button.Link>
						)
					) : null
				}
			>
				{preamble.value && <MediaContent.RteContent text={preamble.value} />}
			</MediaContent>
		</BlockCommonLayout>
	)
}

export { CapioNexusEnlistBlock }
